<template>
  <Header></Header>
     <div>
      <img class="wx" src="../assets/picture/1920_contact.png" alt="" />
     </div>

      <!-- 特許經銷商 -->
    <div class="dealers-container">
    <h1 class="ppjs-title">*40週年彈簧床褥特許經銷商*</h1>

    <!-- 連鎖品牌區 -->
    <section class="section">
      <h2 class="section-title">連鎖品牌</h2>
      <div
        v-for="(chain, chainKey) in chainStores"
        :key="chainKey"
        class="area-section"
      >
        <div class="area-header" @click="toggleChain(chainKey)">
          <h3 class="chain-name">{{ chain.name }}</h3>
          <span class="toggle-icon">{{ expandedChains[chainKey] ? '−' : '+' }}</span>   
        </div>
        <transition name="fade-slide">
          <div v-show="expandedChains[chainKey]" class="stores-grid">
            <div
              v-for="(store, idx) in chain.stores"
              :key="idx"
              class="store-card"
            >
              <h4 class="store-name">{{ store.branch }}</h4>
              <p class="store-address">{{ store.address }}</p>
              <p v-if="store.tel" class="store-address">Tel: {{ store.tel }}</p>
            </div>
          </div>
        </transition>
      </div>
    </section>

    <!-- 地區分佈區 -->
    <section class="section">
      <h2 class="section-title">地區分佈</h2>
      <div
        v-for="(area, areaKey) in regionalStores"
        :key="areaKey"
        class="area-section"
      >
        <div class="area-header" @click="toggleArea(areaKey)">
          <h3>{{ area.name }}</h3>
          <span class="toggle-icon">{{ expandedAreas[areaKey] ? '−' : '+' }}</span>
        </div>
        <transition name="fade-slide">
          <div v-show="expandedAreas[areaKey]" class="stores-grid">
            <div
              v-for="(store, idx) in area.stores"
              :key="idx"
              class="store-card"
            >
              <h4 class="store-name">{{ store.name }}</h4>
              <p class="store-address">{{ store.address }}</p>
              <p v-if="store.tel" class="store-address">Tel: {{ store.tel }}</p>
            </div>
          </div>
        </transition>
      </div>
    </section>
    </div>

    <div class="dealers-container">
      <h1 class="ppjs-title">查詢熱線</h1>
      <div>電話/whatsapp：+852 5991 1131</div>
    </div>
  <Footer></Footer>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { chainStores, regionalStores } from "@/data/dealers";
export default {
  name: "Contact",
  data() {
    return {
      contact_dt: "https://nicedream.top:8202/gw_lmm/contact1.jpg",
            // 折叠状态
      expandedChains: {
        feicui: true,
        aihuangbao: true,
        tongbao: true
      },
      expandedAreas: {
        hk: true,
        kl: true,
        nt: true,
        macau: true
      },
      chainStores,
      regionalStores,
    };
  },
  methods: {
    toggleChain(key) {
      this.expandedChains[key] = !this.expandedChains[key];
    },
    toggleArea(key) {
      this.expandedAreas[key] = !this.expandedAreas[key];
    },
  },
  components: { Header, Footer },
};
</script>

<style scoped>
/* 联系我们 */
.lxwm {
  background-image: url(../assets/picture/addr.png);
  background-position: top center;
  background-repeat: no-repeat;
  width: 100%;
  height: 380px;
  /* background-size: auto 100%; */
}
.lxwm_text {
  width: 1100px;
  margin: 0 auto;
  text-align: left;
}
.dz {
  position: relative;
  top: 50px;
  left: 500px;
  width: 450px;
  padding: 30px 0px 30px 30px;
  background-color: #1b1919;
  opacity: 0.8;
}
.line {
  border-top: 1px solid #ffffff;
  width: 350px;
}




.dealers-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Segoe UI', 'Microsoft JhengHei', 'PingFang HK', sans-serif;
  color: #333;
  line-height: 1.6;
}

.title {
  text-align: center;
  font-size: 2.4rem;
  margin-bottom: 2.5rem;
  color: #2c3e50;
  font-weight: 700;
}

.section {
  margin-bottom: 3rem;
}

.section-title {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #2d3748;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.area-section {
  margin-bottom: 1.8rem;
}

.area-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1.2rem;
  background-color: #f8fafc;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.area-header:hover {
  background-color: #edf7ff;
}

.chain-name,
.area-header h3 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2b6cb0;
}

.toggle-icon {
  font-size: 1.4rem;
  font-weight: bold;
  color: #4a5568;
}

.stores-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.3rem;
  margin-top: 1rem;
  padding: 0 0.5rem;
}

.store-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
}

.store-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.store-name {
  margin: 0 0 0.7rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c5282;
}

.store-address {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.55;
  color: #4a5568;
}

/* 折叠动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.35s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

/* 响应式 */
@media (max-width: 768px) {
  .stores-grid {
    grid-template-columns: 1fr;
  }
  .dealers-container {
    padding: 1.2rem;
  }
  .title {
    font-size: 2rem;
  }
  .section-title {
    font-size: 1.5rem;
  }
}



</style>